import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import React from "react";
import ValidationError from "../submission/ui/ValidationError";
interface TraitWrapperProps {
  readonly label: string;
  readonly readOnly?: boolean | undefined;
  readonly children: React.ReactNode;
  readonly isBoolean?: boolean | undefined;
  readonly className?: string | undefined;
  readonly error?: string | null | undefined;
  readonly id?: string | undefined;
  readonly isFieldFilled?: boolean | undefined;
  readonly labelRightAdornment?: React.ReactNode;
  readonly showRequiredMarker?: boolean | undefined;
  readonly labelTone?: "default" | "muted" | undefined;
  readonly size?: "default" | "sm" | undefined;
}
export const TraitWrapper: React.FC<TraitWrapperProps> = t0 => {
  const $ = _c(54);
  const {
    label,
    readOnly: t1,
    children,
    isBoolean: t2,
    className,
    error,
    id,
    isFieldFilled: t3,
    labelRightAdornment,
    showRequiredMarker: t4,
    labelTone: t5,
    size: t6
  } = t0;
  const readOnly = t1 === undefined ? false : t1;
  const isBoolean = t2 === undefined ? false : t2;
  const isFieldFilled = t3 === undefined ? false : t3;
  const showRequiredMarker = t4 === undefined ? false : t4;
  const labelTone = t5 === undefined ? "default" : t5;
  const size = t6 === undefined ? "default" : t6;
  let t7;
  if ($[0] !== id || $[1] !== label) {
    t7 = id ?? `field-${label.toLowerCase().replace(/\s+/g, "-")}`;
    $[0] = id;
    $[1] = label;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const fieldId = t7;
  const errorId = error ? `${fieldId}-error` : undefined;
  const hasLabelRightAdornment = labelRightAdornment !== undefined && labelRightAdornment !== null;
  const hasError = !!error && !readOnly;
  let labelClassName = labelTone === "muted" ? "tw-text-iron-400 group-focus-visible-within:tw-text-primary-400" : "tw-text-iron-300 group-focus-visible-within:tw-text-primary-400";
  if (readOnly) {
    labelClassName = "tw-text-iron-500";
  } else {
    if (hasError) {
      labelClassName = "tw-text-red-400";
    }
  }
  if (isBoolean) {
    const t8 = `tw-group tw-relative ${className ?? ""}`;
    let t9;
    if ($[3] !== fieldId || $[4] !== label) {
      t9 = <label htmlFor={fieldId} className="tw-min-w-0 tw-flex-1 tw-cursor-pointer tw-truncate tw-text-sm tw-font-medium tw-text-iron-300">{label}</label>;
      $[3] = fieldId;
      $[4] = label;
      $[5] = t9;
    } else {
      t9 = $[5];
    }
    let t10;
    if ($[6] !== children) {
      t10 = <div className="tw-flex-shrink-0">{children}</div>;
      $[6] = children;
      $[7] = t10;
    } else {
      t10 = $[7];
    }
    let t11;
    if ($[8] !== t10 || $[9] !== t9) {
      t11 = <div className="tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-border tw-border-solid tw-border-iron-700/60 tw-bg-iron-900 tw-px-4 tw-py-2.5">{t9}{t10}</div>;
      $[8] = t10;
      $[9] = t9;
      $[10] = t11;
    } else {
      t11 = $[10];
    }
    let t12;
    if ($[11] !== t11 || $[12] !== t8) {
      t12 = <div className={t8}>{t11}</div>;
      $[11] = t11;
      $[12] = t8;
      $[13] = t12;
    } else {
      t12 = $[13];
    }
    return t12;
  }
  const t8 = `tw-group tw-relative ${className ?? ""}`;
  const t9 = `tw-absolute -tw-top-2 tw-left-3 tw-z-10 tw-rounded-sm tw-bg-iron-900 tw-px-1 tw-font-medium tw-transition-all ${hasLabelRightAdornment ? "tw-flex tw-items-center tw-gap-1" : ""} ${size === "sm" ? "tw-text-[11px]" : "tw-text-xs"} ${labelClassName}`;
  let t10;
  if ($[14] !== label) {
    t10 = <span>{label}</span>;
    $[14] = label;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== readOnly || $[17] !== showRequiredMarker) {
    t11 = showRequiredMarker && !readOnly && <span aria-hidden="true" className="tw-text-iron-500">*</span>;
    $[16] = readOnly;
    $[17] = showRequiredMarker;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <span className="tw-inline-flex tw-items-center tw-gap-0.5">{t10}{t11}</span>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== fieldId || $[23] !== labelRightAdornment || $[24] !== t12 || $[25] !== t9) {
    t13 = <label htmlFor={fieldId} className={t9}>{t12}{labelRightAdornment}</label>;
    $[22] = fieldId;
    $[23] = labelRightAdornment;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== children || $[28] !== errorId || $[29] !== fieldId || $[30] !== hasError) {
    let t15;
    if ($[32] !== errorId || $[33] !== fieldId || $[34] !== hasError) {
      t15 = child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            ...child.props,
            id: fieldId,
            "aria-invalid": hasError,
            "aria-describedby": errorId
          });
        }
        return child;
      };
      $[32] = errorId;
      $[33] = fieldId;
      $[34] = hasError;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    t14 = React.Children.map(children, t15);
    $[27] = children;
    $[28] = errorId;
    $[29] = fieldId;
    $[30] = hasError;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[36] !== hasError || $[37] !== hasLabelRightAdornment || $[38] !== isFieldFilled || $[39] !== size) {
    t15 = !hasLabelRightAdornment && isFieldFilled && !hasError && <div className={`tw-pointer-events-none tw-absolute tw-inset-y-0 tw-flex tw-items-center ${size === "sm" ? "tw-right-2.5" : "tw-right-3"}`}><CheckCircleIcon className={`tw-flex-shrink-0 tw-text-emerald-500 ${size === "sm" ? "tw-h-[18px] tw-w-[18px]" : "tw-h-5 tw-w-5"}`} /></div>;
    $[36] = hasError;
    $[37] = hasLabelRightAdornment;
    $[38] = isFieldFilled;
    $[39] = size;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t14 || $[42] !== t15) {
    t16 = <div className="tw-relative tw-rounded-xl tw-bg-iron-950 tw-transition-all tw-duration-200">{t14}{t15}</div>;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t13 || $[45] !== t16) {
    t17 = <div className="tw-relative">{t13}{t16}</div>;
    $[44] = t13;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== error || $[48] !== errorId) {
    t18 = <ValidationError error={error} id={errorId} className="tw-mt-1" />;
    $[47] = error;
    $[48] = errorId;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t17 || $[51] !== t18 || $[52] !== t8) {
    t19 = <div className={t8}>{t17}{t18}</div>;
    $[50] = t17;
    $[51] = t18;
    $[52] = t8;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
};